import type { BadgeTone } from '@/shared/components/ui/Badge';
import type { MeetingStatus } from './types';

export const STATUS_OPTIONS = [
  { value: 'scheduled', label: 'Scheduled' },
  { value: 'completed', label: 'Completed' },
  { value: 'cancelled', label: 'Cancelled' },
];

export const STATUS_TONE: Record<MeetingStatus, BadgeTone> = {
  scheduled: 'info',
  completed: 'success',
  cancelled: 'danger',
};

export const STATUS_LABEL: Record<MeetingStatus, string> = {
  scheduled: 'Scheduled',
  completed: 'Completed',
  cancelled: 'Cancelled',
};

/** Human-friendly date label (e.g. "5 Feb 2030"). */
export function formatDate(date?: string): string {
  if (!date) return '—';
  const d = new Date(`${date}T00:00:00`);
  if (Number.isNaN(d.getTime())) return date;
  return d.toLocaleDateString(undefined, { day: 'numeric', month: 'short', year: 'numeric' });
}

/** Combined date + time label for cards/drawer. */
export function formatWhen(date?: string, time?: string): string {
  const d = formatDate(date);
  return time ? `${d} · ${time}` : d;
}
